import {action, observable} from 'mobx';

class ReportStore{

    constructor(api) {
        this.api = api;
        this.report = null;
        this.reports = [];
        this.reportRequest = {};
        this.loading = false;
        this.polling = false;
        this.baseUrl = '/reports';
    }

    @observable report;
    @observable reports;
    @observable error;
    @observable reportRequest;
    @observable loading;
    @observable polling;
    @observable existingReports = [];

    @action
    setReportRequest(reportRequest){
        this.reportRequest = reportRequest;
    }

    @action
    setPolling = (polling) => {
        this.polling = polling;
    }

    @action
    setReport = (report) => {
        this.report = report;
    }


    @action reset =() =>{
        this.report = null;
        this.reportRequest = {};
        this.loading = false;
        this.polling = false;
    }


    downloadCsv = (url, callback) => {
        this.api.get(url, this.searchFilter)
          .then(response => {
            if (callback) callback(response.data);
          }).catch((e) => {
            this.error = e;
        })
      }    

    @action
    getReports = () => {
        this.loading = true;
        this.api.get(this.baseUrl)
          .then(response => {
            this.loading = false;
            if (response.status === 200) {                                
                this.reports = response.data;
              }
          }).catch((e) => {
            this.error = e;
        })
    }

    @action
    requestReport = () => {
        this.api.post(`${this.baseUrl}/request`,this.reportRequest)
    }

    @action
    setError = (error) =>{
       this.error = error;
    }


}


export default ReportStore;